import React from 'react';
import { TextV2 } from '@withjoy/joykit';
import { SummarySection } from '@shared/components/SummaryCard/SummarySection';
import { ContactInputFields } from '@apps/contactCollector/guest/ContactCollectorGuest.controller';
import { useTranslation } from '@shared/core/i18n/useTranslation';

type ContactInfoSummaryProps = {
  contactValues: Partial<ContactInputFields>;
};

export const ContactInfoSummary = ({ contactValues }: ContactInfoSummaryProps) => {
  const { tq } = useTranslation('eventFormDisplay');

  return (
    <SummarySection
      title={tq`Contact Information`}
      useStack
    >
      {(contactValues.firstName || contactValues.lastName) && (
        <TextV2
          typographyVariant="body1"
          color="mono11"
          paddingLeft={4}
        >
          {[contactValues.firstName, contactValues.lastName].filter(Boolean).join(' ')}
        </TextV2>
      )}
      {contactValues.email && (
        <TextV2
          typographyVariant="body1"
          color="mono11"
          paddingLeft={4}
        >
          {contactValues.email}
        </TextV2>
      )}
      {contactValues.phoneNumber && (
        <TextV2
          typographyVariant="body1"
          color="mono11"
          paddingLeft={4}
        >
          {contactValues.phoneNumber}
        </TextV2>
      )}
    </SummarySection>
  );
};
